import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ProductDetail from "./pages/ProductDetail";
import ProductUpdate from "./pages/ProductUpdate";
import RegisterPage from "./pages/Register";
import ForgotPasswordPage from "./pages/ForgotPassword";
import Wishlist from "./pages/Wishlist";
import ProtectedRoute from "./ProtectedRoute";
import MsrSeasons from "./pages/MsrSeasons";
import MsrCategoryStyle from "./pages/MsrCategoryStyle";
import { ToastContainer } from "react-toastify";
import EmailVarification from "./components/EmailVarification";
import ResetPassword from "./pages/ResetPassword";
import SearchDetailpage from "./pages/SearchDetailpage";
import SearchResults from "./pages/SearchResults";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ResetSystemGeneratedPassword from "./pages/changesytempasseord";
import Sidebarstags from "./pages/Sidebarstags";
import Tagfolder from "./pages/tagfolderdivison";
import NotFoundPage from "./pages/404_page";
import "./App.css";
import { useDispatch } from "react-redux";
import { toggleModal, openModal } from "./Redux/modalSlice";
import PWAInstallModal from "./components/PWAInstallModal";
import TagList from "./pages/TagList";


const App = () => {
  const location = useLocation();
  const [searchInput, setSearchInput] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      dispatch(toggleModal());
    }
  }, []);

  // Detect background page for modal
  // const state = location.state;
  // const backgroundLocation = state && state.backgroundLocation;

  // localStorage.setItem(
  //   "rediectAfterlogin",
  //   window.location.pathname + window.location.search
  // );

  // Pages where header/footer should NOT appear
  const noHeaderFooterPaths = [
    "/login",
    "/auth/reset-password/",
    "/forgot-password",
    "/404",
  ];

  const hideHeaderFooter = noHeaderFooterPaths.includes(location.pathname);

  return (
    <>
      {!hideHeaderFooter && (
        <Header searchInput={searchInput} setSearchInput={setSearchInput} />
      )}

      <PWAInstallModal />

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/auth/reset-password/"
          element={<ResetSystemGeneratedPassword />}
        />
        <Route
          path="/"
          element={
            // <ProtectedRoute>
            <Home />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/:categorySlug/product-detail/:id"
          element={
            <ProtectedRoute>
              <ProductDetail />
            </ProtectedRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/filter-product/*"
          element={
            <ProtectedRoute>
              <ProductUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search-detail"
          element={
            <ProtectedRoute>
              <SearchDetailpage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search-results"
          element={
            <ProtectedRoute>
              <SearchResults setSearchInput={setSearchInput} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tag/:id"
          element={
            <ProtectedRoute>
              <Sidebarstags />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tagfolderdivison"
          element={
            <ProtectedRoute>
              <Tagfolder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wishlist"
          element={
            <ProtectedRoute>
              <Wishlist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/msr-seasons/season"
          element={
            <ProtectedRoute>
              <MsrSeasons />
            </ProtectedRoute>
          }
        />
        <Route
          path="/msr-seasons/year"
          element={
            <ProtectedRoute>
              <MsrSeasons />
            </ProtectedRoute>
          }
        />
        <Route
          path="/msr-seasons/year/:id"
          element={
            <ProtectedRoute>
              <MsrSeasons />
            </ProtectedRoute>
          }
        />
        <Route path="/api/reset-password/*" element={<ResetPassword />} />
        <Route
          path="/msr-seasons/season/*"
          element={
            <ProtectedRoute>
              <MsrCategoryStyle />
            </ProtectedRoute>
          }
        />
        <Route
          path="/msr-seasons/year/:id/*"
          element={
            <ProtectedRoute>
              <MsrCategoryStyle />
            </ProtectedRoute>
          }
        />

        <Route
          path="/all-tag"
          element={
            <ProtectedRoute>
              <TagList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/api/auth/v1/auth/verify-email/*"
          element={<EmailVarification />}
        />

        {/* 404 Page Route */}
        <Route path="*" element={<NotFoundPage />} />

        {/* Catch-all Redirect */}
        {/* <Route path="*" element={<Navigate to="/404" replace />} /> */}
      </Routes>

      <ToastContainer />
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

// This wraps your login in a modal layout
// const LoginModalWrapper = () => {
//   return (
//     <div className="">
//       <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//         <Login />
//       </div>
//     </div>
//   );
// };

export default App;
